export default __webpack_public_path__ + "static/media/h66_b-w.ddd850c5.svg";